import axios from '../utils/axios/axiosApi'

function getDataHistory () { 
    const user = JSON.parse(localStorage.getItem('user'))
    return ({
        DocumentNumber : user.DocumentNumber, 
        DocumentType : user.DocumentType
    })
};

function getDataHistoryDetail (paymentNumber) { 
    const user = JSON.parse(localStorage.getItem('user'))
    return ({
        DocumentNumber : user.DocumentNumber, 
        DocumentType : user.DocumentType,
        PaymentNumber : paymentNumber
    })
};

const getPaymentProductHistoryAsync = () => {
    return new Promise((resolve, reject) => {
        axios.post('ProductPortal/GetProductHistory', getDataHistory())
             .then((response) => {
                resolve(response.data);
             })
             .catch((error) => {
                reject(error);
             });
    })
};

const getPaymentHistoryDetailAsync = paymentNumber => {
    return new Promise((resolve, reject) => {
        axios.post('ProductPortal/GetHistoryDetail', getDataHistoryDetail(paymentNumber))
             .then((response) => {
                resolve(response.data);
             })
             .catch((error) => {
                reject(error);
             });
    })
};

const getPaymentVoucherAsync = paymentNumber => {
    return new Promise((resolve, reject) => {
        axios.get('ProductPortal/GetTransactionDataByReferenceNumber/' + paymentNumber) 
             .then((response) => {
                resolve(response.data);
             })
             .catch((error) => {
                reject(error);
             });
    })
};

const getPaymentPDFAsync = paymentNumber => {
    return new Promise((resolve, reject) => {
        axios.post('ProductPortal/GeneratePaymentPDF', paymentNumber) 
             .then((response) => {
                resolve(response.data);
             })
             .catch((error) => {
                reject(error);
             });
    })
};

export {
    getPaymentProductHistoryAsync,
    getPaymentHistoryDetailAsync,
    getPaymentVoucherAsync,
    getPaymentPDFAsync
}